import styled from 'styled-components';
import { pxToRem } from 'modules/v2/foundation/spacing';
import { themeGet } from 'modules/v2/foundation/theme';
export const Container = styled.div `
  display: grid;
  grid-template-columns: ${pxToRem(120)} 1fr;
  row-gap: ${themeGet('spacing.sm')};
  column-gap: ${themeGet('spacing.xl')};
  align-items: baseline;
`;
export const Term = styled.dt `
  font-size: ${themeGet('fontSize.tiny')};
  color: ${themeGet('colors.text.100')};
  font-weight: ${themeGet('fontWeight.medium')};
  padding-left: ${themeGet('spacing.md')};
`;
